/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_LockInputs */

const cs_workflow_lock = /** @type {(inputs: Workflow_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknout pro úpravy`)
};

const en_workflow_lock = /** @type {(inputs: Workflow_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock for editing`)
};

/**
* | output |
* | --- |
* | "Lock for editing" |
*
* @param {Workflow_LockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_lock = /** @type {((inputs?: Workflow_LockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_LockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_lock(inputs)
	return cs_workflow_lock(inputs)
});